"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-martino-di-lupari": {
    "eb1c4456": [{
      "hkey": "ad49f17d",
      "slug": "monastiero-campretto",
      "name": "Monastiero-Campretto",
      "primary": true,
      "skipSearch": false
    }],
    "campretto": [{
      "hkey": "ad49f17d",
      "slug": "monastiero-campretto",
      "name": "Monastiero-Campretto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-martino-di-lupari"
    }],
    "2a935fd3": [{
      "hkey": "ad49f17d",
      "slug": "monastiero-campretto",
      "name": "Monastiero-Campretto",
      "primary": true,
      "skipSearch": false
    }],
    "monastiero": [{
      "hkey": "ad49f17d",
      "slug": "monastiero-campretto",
      "name": "Monastiero-Campretto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;